import { create } from 'zustand';

type TransactionMonitoringModalState = {
    isOpen: boolean;
    bankTransactionRecordId: string | null;
    openModal: (bankTransactionRecordId: string) => void;
    closeModal: () => void;
};

export const useTransactionMonitoringModalStore =
    create<TransactionMonitoringModalState>((set) => ({
        isOpen: false,
        bankTransactionRecordId: null,
        openModal: (bankTransactionRecordId: string) =>
            set({ isOpen: true, bankTransactionRecordId }),
        closeModal: () => {
            set({ isOpen: false });
            // Clear the content after closing the modal
            setTimeout(() => {
                set({ bankTransactionRecordId: null });
            }, 100);
        }
    }));
